import React, { useEffect, useState } from "react";
import Modal from "../../../../parts/modal";
import ImageWidgetUploadInput from "../../../../parts/inputs/image-widget-upload";

export const EditVideoPlaylistModal = ({ query, locals }) => {
  const [currentPlaylist, setCurrentPlaylist] = useState({});

  useEffect(() => {
    //load information to edit a playlist in the modal
    if (locals.videoPlaylists && query.playlistid) {
      const findPlaylist = locals.videoPlaylists.find(
        ({ _id }) => _id === query.playlistid
      );
      setCurrentPlaylist(findPlaylist);
    }
  }, [locals.videoPlaylists, query.playlistid]);

  /**
   * Validate if the playlist's form is valid
   * @returns
   */
  const validationPlaylistSubmit = () => {
    if (
      Object.keys(currentPlaylist).length > 0 &&
      currentPlaylist.description.length > 0 &&
      currentPlaylist.name.length > 0
    ) {
      return true;
    }
    return false;
  };

  /**
   * Assign the value of the create playlist's state
   * @param {*} param0
   */
  const handleInputPlayListChange = ({ target }) => {
    const newState = Object.assign({}, currentPlaylist, {
      [target.name]: target.value,
    });
    setCurrentPlaylist(newState);
  };

  return (
    <form
      encType="multipart/form-data"
      method="POST"
      data-noreset
      action={`/actions/video-playlist/save/${currentPlaylist._id}`}
    >
      {" "}
      <Modal className="Widget-Modal" width={"1014px"}>
        {!!Object.keys(currentPlaylist).length > 0 && (
          <div>
            <div
              className="add-new-div"
              style={{
                background: "#181818",
                border: "none",
                boxShadow: "0px 4px 8px #00000029",
                justifyContent: "center",
              }}
            >
              <ImageWidgetUploadInput
                name="image"
                prefix="Video playlist"
                defaultValue={currentPlaylist.image}
                backgroundedit={`${currentPlaylist.image.s3Path}`}
                hasImage={true}
              />
              <div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ padding: 0 }} className="column">
                    <div className="label req"> Video playlist name </div>
                    <input
                      name="name"
                      className="input-videoplaylist-name text-input"
                      placeholder={`Enter Name`}
                      value={currentPlaylist.name}
                      onChange={handleInputPlayListChange}
                    />
                  </div>
                  <div style={{ padding: 0 }} className="column">
                    <div className="label req"> Description </div>
                    <textarea
                      name="description"
                      className="textarea-input"
                      value={currentPlaylist.description}
                      onChange={handleInputPlayListChange}
                      placeholder="Enter description"
                    />
                  </div>
                  <input
                    name="widget"
                    style={{ display: "none" }}
                    defaultValue={currentPlaylist.widget}
                  />
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    type="submit"
                    className={
                      validationPlaylistSubmit()
                        ? "save-macro-btn"
                        : "save-macro-disabled-btn save-macro-btn"
                    }
                    disabled={!validationPlaylistSubmit()}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </form>
  );
};
